import React, { ReactElement } from 'react';
import { isWeb } from '../../utils/util';

interface IPCScroller {
  children?: React.ReactElement;
}
// 考虑到可能有一些需要绝对定位的东西，所以在外面加了这一层，方便一点，虽然目前可能没有了
export default function(props: IPCScroller) {
  const { children } = props;
  if (!isWeb()) {
    return children || null;
  }

  return <div className="pc-scroller">{children}</div>;
}
